import React from 'react';

import CharsheetLong from './CharsheetLong.js'

// ----------------------------------------------------------------------------------
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function Index(props) {

    // ---------- return html (jsx) ----------

    return (
        <CharsheetLong {...props} />
    )

    };  // end of function


export default Index